export default `/* Ids Overlay Component */
:host {
  display: block;
  pointer-events: none;
}

:host([background-color=page]) {
  z-index: -1;
}

.ids-overlay {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  display: none;
  outline: 0;
  position: fixed;
  pointer-events: none;
  background-color: rgb(var(--ids-overlay-background-color)/0);
  transition: background-color 0.2s;
}
.ids-overlay.visible {
  display: block;
  background-color: rgb(var(--ids-overlay-background-color)/0.3);
  pointer-events: auto;
}

:host(.contained)::part(overlay) {
  position: absolute;
}

[slot=widget-content], [slot=card-content] {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtbW9kYWwiLCJzb3VyY2VzIjpbImlkcy1vdmVybGF5LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBR0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTs7O0FBSUo7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi8qIElkcyBPdmVybGF5IENvbXBvbmVudCAqL1xuOmhvc3Qge1xuICBkaXNwbGF5OiBibG9jaztcbiAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG59XG5cbjpob3N0KFtiYWNrZ3JvdW5kLWNvbG9yPVwicGFnZVwiXSkge1xuICB6LWluZGV4OiAtMTtcbn1cblxuLmlkcy1vdmVybGF5IHtcbiAgaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBkaXNwbGF5OiBub25lO1xuICBvdXRsaW5lOiAwO1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xuXG4gIC8vIEFuaW1hdGlvblxuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2IodmFyKC0taWRzLW92ZXJsYXktYmFja2dyb3VuZC1jb2xvcikgLyAwKTtcbiAgdHJhbnNpdGlvbjogYmFja2dyb3VuZC1jb2xvciAwLjJzO1xuXG4gICYudmlzaWJsZSB7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogcmdiKHZhcigtLWlkcy1vdmVybGF5LWJhY2tncm91bmQtY29sb3IpIC8gMC4zKTtcbiAgICBwb2ludGVyLWV2ZW50czogYXV0bztcbiAgfVxufVxuXG46aG9zdCguY29udGFpbmVkKTo6cGFydChvdmVybGF5KSB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbn1cblxuW3Nsb3Q9XCJ3aWRnZXQtY29udGVudFwiXSxbc2xvdD1cImNhcmQtY29udGVudFwiXSB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgbWluLWhlaWdodDogMTAwcHg7XG59XG4iXX0= */`;
